import React, { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  id: {
    brand: "Jastip BHX–Gresik",
    nav_trips: "Rute & Trip",
    nav_book: "Buat Titipan",
    nav_track: "Lacak Kiriman",
    nav_admin: "Portal Admin",
    cta_book: "Buat Titipan",
    rate_label: "Kurs",

    // hero
    hero_badge: "Jasa Titip Birmingham ⇄ Gresik",
    hero_title: "Titip barang antara Inggris & Indonesia dengan aman",
    hero_sub: "Kelola pemesanan, biaya jastip, kapasitas bagasi, dan lacak kiriman Anda dalam satu tempat.",
    hero_cta_book: "Mulai Titipan",
    hero_cta_track: "Lacak Kiriman",

    // trips
    trips_title: "Trip Jastip Aktif",
    trips_sub: "Pilih trip untuk membuat titipan",
    route: "Rute",
    deadline: "Batas terima barang",
    capacity: "Kapasitas bagasi",
    remaining: "Sisa",
    used: "Terpakai",
    of: "dari",
    dropoff: "Alamat drop-off",
    pickup: "Alamat pick-up",
    book_this_trip: "Titip di trip ini",
    trip_full: "Trip penuh",
    no_trips: "Belum ada trip aktif. Silakan cek kembali nanti.",
    status: "Status",

    // booking
    booking_title: "Formulir Titipan",
    booking_sub: "Lengkapi data di bawah untuk membuat titipan",
    select_trip: "Pilih Trip",
    customer_info: "Data Pemesan",
    full_name: "Nama lengkap",
    phone: "Nomor telepon",
    whatsapp: "Nomor WhatsApp",
    total_weight: "Perkiraan total berat (kg)",
    is_bulky: "Barang termasuk bulky / besar",
    items: "Daftar Barang",
    item_hint: "Struk disarankan untuk barang baru atau mewah agar memperjelas nilai barang saat penilaian bea/pajak.",
    item_name: "Nama / deskripsi barang",
    qty: "Jumlah",
    price_value: "Harga / nilai barang",
    receipt: "Struk (opsional)",
    upload: "Unggah",
    uploaded: "Terunggah",
    add_item: "Tambah barang",
    remove: "Hapus",
    delivery_method: "Metode Pengambilan",
    delivery_deliver: "Antar ke alamat penerima di Indonesia",
    delivery_pickup: "Ambil sendiri di lokasi",
    recipient_address: "Alamat penerima",
    who_pays: "Siapa yang membayar ongkos kirim domestik",
    payer_recipient: "Penerima",
    payer_customer: "Pemesan",
    summary: "Ringkasan",
    est_fee: "Perkiraan biaya jastip",
    est_fee_hint: "Perkiraan berdasarkan berat yang Anda masukkan. Biaya final dihitung setelah penimbangan ulang oleh admin.",
    terms_title: "Syarat & Ketentuan",
    terms_accept: "Saya membaca dan menyetujui Syarat & Ketentuan",
    view_terms: "Lihat Syarat & Ketentuan",
    submit_booking: "Kirim Titipan",
    booking_success: "Titipan berhasil dibuat!",
    your_ref: "Nomor referensi Anda",
    save_ref: "Simpan nomor ini untuk melacak kiriman Anda.",
    book_another: "Buat titipan lain",
    track_now: "Lacak sekarang",

    // validation
    err_required: "Wajib diisi",
    err_name: "Masukkan nama lengkap",
    err_phone: "Masukkan nomor telepon yang valid",
    err_weight: "Berat harus lebih dari 0",
    err_terms: "Anda harus menyetujui Syarat & Ketentuan",
    err_item: "Isi minimal satu barang",
    err_item_fields: "Lengkapi nama, jumlah, dan harga untuk setiap barang",
    err_trip: "Pilih trip terlebih dahulu",
    err_recipient: "Masukkan alamat penerima",

    // track
    track_title: "Lacak Kiriman Anda",
    track_sub: "Masukkan nomor referensi dan nomor telepon Anda",
    ref_number: "Nomor referensi (mis. JST-2026-BHX123)",
    track_btn: "Lacak",
    track_not_found: "Tidak ditemukan titipan dengan referensi & nomor telepon tersebut",
    timeline: "Status Perjalanan",
    fee_breakdown: "Rincian Biaya",
    weight_est: "Berat perkiraan",
    weight_adj: "Berat setelah ditimbang",
    final_fee: "Biaya jastip final",
    customs: "Bea / pajak",
    domestic_cost: "Ongkos kirim domestik",
    awb: "No. resi domestik (AWB)",
    pickup_info: "Info pengambilan",
    pickup_ready: "Siap diambil pada",
    exchange_rate_used: "Kurs yang digunakan",
    payment: "Pembayaran",
    paid: "Lunas",
    unpaid: "Belum lunas",
    chat_wa: "Chat WhatsApp ke Zaki / Aini",
    feedback_title: "Bagaimana pengalaman Anda?",
    feedback_satisfied: "Puas",
    feedback_not: "Tidak puas",
    feedback_comment: "Komentar atau saran (opsional)",
    feedback_submit: "Kirim masukan",
    feedback_thanks: "Terima kasih atas masukan Anda!",
    feedback_given: "Masukan sudah dikirim. Terima kasih!",

    payment_info: "Informasi Pembayaran",
    payment_note: "Barang akan dikirim setelah pembayaran dikonfirmasi oleh admin.",
    account_name_l: "Atas nama",
    account_number_l: "No. rekening",
    mark_paid: "Saya sudah bayar",
    payment_awaiting: "Menunggu verifikasi",
    paid_thanks: "Terima kasih, pembayaran Anda sedang menunggu verifikasi admin.",
    copy: "Salin",
    orders_closed: "Pemesanan ditutup",
    trip_inactive: "Trip nonaktif",
    trip_open: "Terbuka",
    waiting_notice: "Pesanan Anda masuk daftar tunggu dan menunggu konfirmasi admin sebelum dapat melanjutkan pembayaran.",

    // contact
    contact_title: "Kontak Jastip",
    contact_managers: "Kontak",
    wa_available: "WhatsApp tersedia",
    wa_not: "Tidak tersedia di WhatsApp",

    // misc
    loading: "Memuat...",
    cancel: "Batal",
    save: "Simpan",
    close: "Tutup",
  },
  en: {
    brand: "Jastip BHX–Gresik",
    nav_trips: "Routes & Trips",
    nav_book: "Create Booking",
    nav_track: "Track Shipment",
    nav_admin: "Admin Portal",
    cta_book: "Create Booking",
    rate_label: "Rate",

    hero_badge: "Personal Shopping Birmingham ⇄ Gresik",
    hero_title: "Ship personal items between the UK & Indonesia, safely",
    hero_sub: "Manage bookings, jastip fees, baggage capacity, and track your shipment — all in one place.",
    hero_cta_book: "Start a Booking",
    hero_cta_track: "Track Shipment",

    trips_title: "Active Jastip Trips",
    trips_sub: "Choose a trip to create your booking",
    route: "Route",
    deadline: "Latest date to receive goods",
    capacity: "Baggage capacity",
    remaining: "Remaining",
    used: "Used",
    of: "of",
    dropoff: "Drop-off address",
    pickup: "Pick-up address",
    book_this_trip: "Book this trip",
    trip_full: "Trip full",
    no_trips: "No active trips yet. Please check back later.",
    status: "Status",

    booking_title: "Booking Form",
    booking_sub: "Fill in the details below to create your booking",
    select_trip: "Select Trip",
    customer_info: "Customer Details",
    full_name: "Full name",
    phone: "Phone number",
    whatsapp: "WhatsApp number",
    total_weight: "Total estimated weight (kg)",
    is_bulky: "Shipment is bulky / oversized",
    items: "List of Goods",
    item_hint: "Receipts are recommended for new or luxury goods to help clarify declared values when customs duties or taxes are assessed.",
    item_name: "Item name / description",
    qty: "Quantity",
    price_value: "Purchase price / value",
    receipt: "Receipt (optional)",
    upload: "Upload",
    uploaded: "Uploaded",
    add_item: "Add item",
    remove: "Remove",
    delivery_method: "Collection Method",
    delivery_deliver: "Deliver to recipient's address in Indonesia",
    delivery_pickup: "I will pick up the goods myself",
    recipient_address: "Recipient address",
    who_pays: "Who pays the domestic delivery cost",
    payer_recipient: "Recipient",
    payer_customer: "Customer",
    summary: "Summary",
    est_fee: "Estimated jastip fee",
    est_fee_hint: "Estimate based on the weight you entered. The final fee is calculated after the admin reweighs your goods.",
    terms_title: "Terms & Conditions",
    terms_accept: "I have read and accept the Terms & Conditions",
    view_terms: "View Terms & Conditions",
    submit_booking: "Submit Booking",
    booking_success: "Booking created successfully!",
    your_ref: "Your booking reference",
    save_ref: "Save this reference to track your shipment.",
    book_another: "Create another booking",
    track_now: "Track now",

    err_required: "Required",
    err_name: "Enter your full name",
    err_phone: "Enter a valid phone number",
    err_weight: "Weight must be greater than 0",
    err_terms: "You must accept the Terms & Conditions",
    err_item: "Add at least one item",
    err_item_fields: "Fill in name, quantity, and price for each item",
    err_trip: "Please select a trip first",
    err_recipient: "Enter the recipient address",

    track_title: "Track Your Shipment",
    track_sub: "Enter your booking reference and phone number",
    ref_number: "Booking reference (e.g. JST-2026-BHX123)",
    track_btn: "Track",
    track_not_found: "No booking found with that reference and phone number",
    timeline: "Shipment Timeline",
    fee_breakdown: "Fee Breakdown",
    weight_est: "Estimated weight",
    weight_adj: "Reweighed weight",
    final_fee: "Final jastip fee",
    customs: "Customs / taxes",
    domestic_cost: "Domestic delivery cost",
    awb: "Domestic AWB / tracking no.",
    pickup_info: "Pick-up information",
    pickup_ready: "Ready for collection on",
    exchange_rate_used: "Exchange rate used",
    payment: "Payment",
    paid: "Paid",
    unpaid: "Unpaid",
    chat_wa: "Chat on WhatsApp with Zaki / Aini",
    feedback_title: "How was your experience?",
    feedback_satisfied: "Satisfied",
    feedback_not: "Not satisfied",
    feedback_comment: "Comment or suggestion (optional)",
    feedback_submit: "Submit feedback",
    feedback_thanks: "Thank you for your feedback!",
    feedback_given: "Feedback already submitted. Thank you!",

    payment_info: "Payment Information",
    payment_note: "Goods are shipped once payment is confirmed by the admin.",
    account_name_l: "Account name",
    account_number_l: "Account number",
    mark_paid: "I have paid",
    payment_awaiting: "Awaiting verification",
    paid_thanks: "Thank you, your payment is awaiting admin verification.",
    copy: "Copy",
    orders_closed: "Orders closed",
    trip_inactive: "Trip inactive",
    trip_open: "Open",
    waiting_notice: "Your booking is on the waiting list and awaiting admin confirmation before you can proceed to payment.",

    contact_title: "Jastip Contacts",
    contact_managers: "Contacts",
    wa_available: "WhatsApp available",
    wa_not: "Not available on WhatsApp",

    loading: "Loading...",
    cancel: "Cancel",
    save: "Save",
    close: "Close",
  },
};

// Shared labels
export const DIRECTION_LABEL = {
  bhx_gresik: "Birmingham → Gresik",
  gresik_bhx: "Gresik → Birmingham",
};

export const TRIP_STATUS = {
  open: { id: "Buka", en: "Open" },
  closed: { id: "Tutup", en: "Closed" },
  in_transit: { id: "Dalam perjalanan", en: "In Transit" },
  arrived: { id: "Tiba", en: "Arrived" },
  completed: { id: "Selesai", en: "Completed" },
};

export const TRACK_STATUS = {
  waiting_list: { id: "Daftar tunggu", en: "Waiting list" },
  confirmed: { id: "Dikonfirmasi admin", en: "Booking confirmed" },
  booking_received: { id: "Titipan diterima", en: "Booking received" },
  goods_received: { id: "Barang diterima", en: "Goods received" },
  reweighed: { id: "Penimbangan ulang selesai", en: "Reweighing completed" },
  packed: { id: "Dikemas / dikemas ulang", en: "Packed / repacked" },
  departed: { id: "Berangkat", en: "Departed" },
  arrived: { id: "Tiba di negara tujuan", en: "Arrived in destination country" },
  customs_entered: { id: "Bea masuk dicatat", en: "Customs charges entered" },
  ready_or_delivery: { id: "Siap diambil / dikirim domestik", en: "Ready for pick-up / sent for delivery" },
  delivered: { id: "Terkirim", en: "Delivered" },
  completed: { id: "Selesai", en: "Completed" },
};

export const CONTACT = {
  managers: "Zaki / Aini",
  whatsapp: "+62 856-4108-8857",
  whatsapp_intl: "6285641088857",
  uk_phone: "+44 7518 802246",
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("jastip_lang") || "id");
  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "id" ? "en" : "id";
      localStorage.setItem("jastip_lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => DICT[lang][key] ?? DICT.en[key] ?? key, [lang]);
  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
export const statusLabel = (map, key, lang) => (map[key] ? map[key][lang] : key);
